/**
 * @author Olga Milczek <olga.milczek@movecloser.pl>
 */
export enum BadgeShape {
  Pill = 'pill',
  Rectangle = ''
}
